import React from 'react';
import logoSvg from '../../assets/images/logo-immosight.png';
import './OnboardingLayout.css';

/**
 * Minimal layout for the onboarding flow.
 * No sidebar, no auth guard, no user dropdown.
 * Topbar: logo left, support + rate links right.
 */
const OnboardingLayout = ({ children }) => {
  return (
    <div className="ob-layout">
      <header className="ob-topbar">
        <a href="/" className="ob-topbar-logo-link" aria-label="ImmoSight">
          <img src={logoSvg} alt="ImmoSight" height={26} style={{ width: 'auto' }} />
        </a>
        <div className="ob-topbar-actions">
          <a
            href="mailto:support@immosight.app"
            className="ob-topbar-action-link"
          >
            Support
          </a>
          <a
            href="https://chromewebstore.google.com/detail/nkckdnigaikighmfhjighclielepmobl?utm_source=item-share-cb"
            target="_blank"
            rel="noopener noreferrer"
            className="ob-topbar-action-link"
          >
            Bewerten
          </a>
        </div>
      </header>
      <main className="ob-content">
        {children}
      </main>
    </div>
  );
};

export default OnboardingLayout;
